export function constantZero() {
  return 0;
}

export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-hierarchy/src/constant.js
// module id = ../../../../d3-hierarchy/src/constant.js
// module chunks = 4